import { render, staticRenderFns } from "./WorkPlansTable.vue?vue&type=template&id=170087f3&"
import script from "./WorkPlansTable.vue?vue&type=script&lang=js&"
export * from "./WorkPlansTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports